import { ApiClient } from "@/shared/services/api-client";
import {
  SignUpPassInitGetRequestModel,
  SignUpPassInitGetResponseModel
} from "@/features/user/services/sign-up-pass-model";
import { HttpResponse } from "@/shared/config/globals";

export class SignUpPassApi {
  /**
   * サインアップパスワード設定ページ表示前処理API
   */
  public signUpPassInit = async (
    param: SignUpPassInitGetRequestModel
  ): Promise<HttpResponse<SignUpPassInitGetResponseModel>> => {
    const path = `/api/sign_up_pass/init`;

    const res = await ApiClient.instance.get<SignUpPassInitGetResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    return res;
  };
}
